var RaveitCart = (function () {
  var drawer = document.getElementById('rv-cart-drawer');
  var overlay = document.getElementById('rv-cart-overlay');
  var body = document.getElementById('rv-cart-body');
  var footer = document.getElementById('rv-cart-footer');
  var totalEl = document.getElementById('rv-cart-total-price');

  function open() {
    refresh();
    drawer.classList.add('rv-open');
    overlay.classList.add('rv-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function close() {
    drawer.classList.remove('rv-open');
    overlay.classList.remove('rv-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function updateCount(n) {
    var countEl = document.querySelector('.rv-cart-count');
    if (n > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'rv-cart-count';
        document.getElementById('rv-cart-btn').appendChild(countEl);
      }
      countEl.textContent = n;
      countEl.style.display = '';
    } else if (countEl) {
      countEl.style.display = 'none';
    }
  }

  function renderItems(cart) {
    updateCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="rv-cart-empty">Sepetiniz boş.</p>';
      footer.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="rv-cart-item" data-key="' + item.key + '">';
      html += '<div class="rv-cart-item-img">';
      if (item.image) {
        html += '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="rv-cart-item-info">';
      html += '<span class="rv-cart-item-name">' + item.product_title + '</span>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<span class="rv-cart-item-variant">' + item.variant_title + '</span>';
      }
      html += '<span class="rv-cart-item-price">' + formatMoney(item.line_price) + '</span>';
      html += '</div>';
      html += '<button class="rv-cart-item-remove" data-key="' + item.key + '" type="button">Kaldır</button>';
      html += '</div>';
    });
    body.innerHTML = html;

    totalEl.textContent = formatMoney(cart.total_price);
    footer.style.display = '';

    body.querySelectorAll('.rv-cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(this.dataset.key);
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'EUR' });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderItems)
      .catch(function () {});
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(renderItems)
      .catch(function () {});
  }

  function init() {
    if (!drawer) return;

    var cartBtn = document.getElementById('rv-cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    var closeBtn = document.getElementById('rv-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    var form = document.getElementById('rv-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.rv-add-to-cart');
      var formData = new FormData(form);

      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(function () {
          btn.textContent = 'Eklendi ✓';
          btn.classList.add('added');
          setTimeout(function () {
            btn.textContent = 'ADD TO CART';
            btn.classList.remove('added');
            btn.disabled = false;
          }, 1200);
          open();
        })
        .catch(function () {
          btn.textContent = 'Hata — tekrar dene';
          btn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return { open: open, close: close, refresh: refresh };
})();
